import React from 'react';
import { Box, Grid, Button } from '@mui/material';
import { WhatsApp as WhatsAppIcon } from '@mui/icons-material';
import FitnessCenterIcon from '@mui/icons-material/FitnessCenter';
import { ASSETS, SOCIAL } from '../utils/constants';
import HeroPhoto from '../assets/Mario_bento_foto_2.jpg'
import HeroTitle from '../assets/nome_sem_fundo.png'

const HeroSection = () => (
  <Box sx={{ bgcolor: 'black', py: 8, overflow: 'hidden', width: '100%', px: { xs: 2, md: 5 } }}>
    <Grid container spacing={4} alignItems="center" sx={{ width: '100%', m: 0 }}>
      {/* Foto */}
      <Grid item xs={12} md={6} sx={{ pl: 0 }}>
        <Box 
          component="img" 
          src={HeroPhoto} 
          alt="Mario Bento Foto"
          sx={{ 
            width: '100%', 
            maxWidth: 500, 
            borderRadius: 1, 
            boxShadow: '0px 0px 20px rgba(211, 47, 47, 0.3)',
            display: 'block',
            // No mobile centraliza, no desktop alinha a esquerda
            mx: { xs: 'auto', md: 0 } 
          }} 
        />
      </Grid>
      
      {/* Nome + CTA */}
      <Grid item xs={12} md={6} sx={{ textAlign: 'left' }}>
        <Box 
          component="img" 
          src={HeroTitle} 
          alt="Mario Bento Nome"
          sx={{ width: '100%', maxWidth: 600, mb: 4, display: 'block', ml: 0 }} 
        />
        <Box sx={{ display: 'flex', justifyContent: { xs: 'center', md: 'flex-start' } }}>
          <Button 
            variant="contained" 
            color="primary" 
            size="large"
            startIcon={<FitnessCenterIcon />}
            href={SOCIAL.avaliacaoFisica}
            target="_blank"
            sx={{
              fontWeight: 800, 
              fontSize: { xs: '0.9rem', sm: '1rem', md: '1.1rem' }, 
              padding: { xs: '12px 24px', md: '16px 40px' }, 
              borderRadius: '50px', 
              whiteSpace: 'nowrap', 
              letterSpacing: { xs: 0.5, md: 1 },
              boxShadow: '0 8px 20px rgba(255, 214, 0, 0.4)',
              width: 'auto', 
              transition: 'all 0.3s ease',
              '&:hover': { 
                transform: 'translateY(-3px) scale(1.02)', 
                boxShadow: '0 12px 30px rgba(255, 214, 0, 0.7)' 
              }
            }}
          >
            SEJA MEU ALUNO
          </Button>
        </Box>
      </Grid>
    </Grid>
  </Box>
);

export default HeroSection;